
import { ROUTE_NAME, ROUTE_PATHS } from "@/router/constants";
import {
  dashboard,
  digitalVault,
  document,
  estatePlan,
  legacy,
  logOut,
  profile,
  security,
  tutorial,
  userRoles,
  notificationIcon,
} from "./commonSvg";
import { useI18n } from "vue-i18n";

export const menuItems = [
  {
    id: 1,
    label: ROUTE_NAME.DASHBOARD,
    path: ROUTE_PATHS.DASHBOARD,
    icon: dashboard,
  },
  {
    id: 2,
    label: ROUTE_NAME.MY_ESTATE_PLAN,
    path: ROUTE_PATHS.MY_ESTATE_PLAN,
    icon: estatePlan,
  },
  {
    id: 3,
    label: ROUTE_NAME.DIGITAL_VAULT,
    path: ROUTE_PATHS.DIGITAL_VAULT,
    icon: digitalVault,
  },
  {
    id: 4,
    label: ROUTE_NAME.LEGACY,
    path: ROUTE_PATHS.LEGACY,
    icon: legacy({ width: "24", height: "25" }),
  },
  {
    id: 5,
    label: ROUTE_NAME.DOCUMENTS,
    path: ROUTE_PATHS.DOCUMENTS,
    icon: document,
  },
  {
    id: 6,
    label: ROUTE_NAME.NOTIFICATIONS,
    path: ROUTE_PATHS.NOTIFICATIONS,
    icon: notificationIcon(),
  },
];

export const getRightPanelMenuItems = () => {
  const { t } = useI18n();
  return [
    {
      id: 1,
      label: t('rolesModule.moduleTitle'),
      icon: userRoles,
      path: ROUTE_PATHS.ROLES,
    },
    {
      id: 2,
      label: t('securityModule.sidebarTitle'),
      icon: security,
      path: ROUTE_PATHS.SECURITY,
    },
    {
      id: 3,
      label: t('profileLabels.header'),
      icon: profile,
      path: ROUTE_PATHS.PROFILE,
    },
    {
      id: 4,
      label: t('rightPanelMenuLabel.howLVEDWorks'),
      icon: tutorial,
      path: ROUTE_PATHS.TUTORIAL,
    },
    {
      id: 5,
      label: t('commonLabels.exit'),
      icon: logOut,
    },
  ];
};
